export type CurrencyCode = 'USD' | 'EUR' | 'GBP' | 'JPY' | 'CHF' | 'CAD' | 'AUD' | 'CNY' | 'AED' | 'SAR';

export interface CurrencyOption {
    value: CurrencyCode;
    label: string;
    symbol: string;
}

export const CURRENCIES: CurrencyOption[] = [
    { value: 'USD', label: 'USD - US Dollar', symbol: '$' },
    { value: 'EUR', label: 'EUR - Euro', symbol: '€' },
    { value: 'GBP', label: 'GBP - British Pound', symbol: '£' },
    { value: 'JPY', label: 'JPY - Japanese Yen', symbol: '¥' },
    { value: 'CHF', label: 'CHF - Swiss Franc', symbol: 'CHF' },
    { value: 'CAD', label: 'CAD - Canadian Dollar', symbol: 'C$' },
    { value: 'AUD', label: 'AUD - Australian Dollar', symbol: 'A$' },
    { value: 'CNY', label: 'CNY - Chinese Yuan', symbol: '¥' },
    { value: 'AED', label: 'AED - UAE Dirham', symbol: 'د.إ' },
    { value: 'SAR', label: 'SAR - Saudi Riyal', symbol: '﷼' },
];

export const getCurrencyByCode = (code: string): CurrencyOption | undefined => {
    return CURRENCIES.find(c => c.value === code);
};
